module.exports = __webpack_public_path__ + "images/external_images/review-generation.png";